import { PercentPipe } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { enableProdMode, importProvidersFrom } from '@angular/core';
import { HAMMER_GESTURE_CONFIG, HammerModule, bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter, withInMemoryScrolling } from '@angular/router';

import { provideLoaders } from '@frontend/loaders';
import { AppComponent, STORE_PREFIX, bootloader, provideVanillaCore } from '@frontend/vanilla/core';
import { GlobalSearchModule } from '@globalsearch/productstub';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { appRoutes } from './app.routes';
import { AppEffects } from './effects/app.effects';
import { environment } from './environments/environment';
import { PromoHttpErrorInterceptor } from './errorHandling/promo-http-error.interceptor';
import { HammerConfig } from './myHammer.config';
import { metaReducers, reducers } from './reducers';

if (environment.production) {
    enableProdMode();
}

performance.mark('app-boot-start');
bootloader().then(() => {
    bootstrapApplication(AppComponent, {
        providers: [
            provideRouter(appRoutes, withInMemoryScrolling({ scrollPositionRestoration: 'enabled', anchorScrolling: 'enabled' })),
            provideAnimations(),
            provideVanillaCore(),
            provideLoaders(),
            provideHttpClient(withInterceptorsFromDi()),
            importProvidersFrom(
                StoreModule.forRoot(reducers, {
                    metaReducers,
                    runtimeChecks: {
                        strictStateImmutability: false,
                        strictActionImmutability: false,
                    },
                }),
                EffectsModule.forRoot([AppEffects]),
            ),
            importProvidersFrom(GlobalSearchModule.forRoot()),
            importProvidersFrom(HammerModule),
            PercentPipe,
            { provide: STORE_PREFIX, useValue: 'promo.' },
            { provide: HAMMER_GESTURE_CONFIG, useClass: HammerConfig },
            {
                provide: HTTP_INTERCEPTORS,
                useClass: PromoHttpErrorInterceptor,
                multi: true,
            },
        ],
    })
        .then(() => {
            performance.mark('app-boot-end');
            performance.measure('app-boot', 'app-boot-start', 'app-boot-end');
        })
        // eslint-disable-next-line no-console
        .catch((err) => console.error(err));
});
